import React from 'react'

const SvgFacebook = ({ fill = '#333333', ...props }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    fill='none'
    version='1.1'
    width='14'
    height='14'
    viewBox='0 0 14 14'
  >
    <defs>
      <clipPath id='master_svg0_126_6133'>
        <rect x='0' y='0' width='14' height='14' rx='0' />
      </clipPath>
    </defs>
    <g clipPath='url(#master_svg0_126_6133)'>
      <g>
        <path
          d='M14,7.02562C14,3.14583,10.8656,0,7,0C3.13435,0,0,3.14583,0,7.02562C0,10.3202,2.25976,13.085,5.30929,13.8446L5.30929,9.17299L3.86565,9.17299L3.86565,7.02562L5.30929,7.02562L5.30929,6.10072C5.30929,3.70953,6.38729,2.60113,8.72694,2.60113C9.17082,2.60113,9.93588,2.68875,10.2488,2.77554L10.2488,4.72122C10.0833,4.70386,9.79671,4.69477,9.44012,4.69477C8.29212,4.69477,7.84906,5.13118,7.84906,6.26603L7.84906,7.02562L10.1352,7.02562L9.74235,9.17298L7.84824,9.17298L7.84824,14C11.3136,13.5793,14,10.617,14,7.02562Z'
          fill={fill}
          fillOpacity='1'
          style={{ mixBlendMode: 'passthrough' }}
        />
      </g>
    </g>
  </svg>
)

export default SvgFacebook
